export enum BankAccountEntity {
    employment = 'employment',
    organization = 'organization',
}
